import { Locale, Step } from 'react-joyride';

export const SITT_JOYRIDE_LOCALE: Locale = {
    back: 'Anterior',
    close: 'Cerrar',
    last: 'Entendido',
    next: 'Siguiente',
    nextWithProgress: 'Siguiente ({current} de {total})',
    open: 'Abrir guía',
    skip: 'Omitir tutorial',
};

export const sittJoyrideBaseOptions = {
    continuous: true,
    showProgress: true,
    showSkipButton: true,
    disableOverlayClose: true,
    scrollToFirstStep: true,
    spotlightClicks: false,
    locale: SITT_JOYRIDE_LOCALE,
    styles: {
        options: {
            primaryColor: '#154750',
            textColor: '#212529',
            zIndex: 10000,
        },
        tooltip: {
            borderRadius: 8,
            fontSize: '0.9rem',
        },
        buttonNext: {
            borderRadius: 20,
            fontSize: '0.85rem',
        },
        buttonBack: {
            fontSize: '0.85rem',
        },
        buttonSkip: {
            fontSize: '0.85rem',
        },
    },
};

export function joyrideStep(
    target: string,
    title: string,
    content: string,
    placement: Step['placement'] = 'bottom',
): Step {
    return { target, title, content, placement, skipBeacon: true };
}

export function joyrideWelcome(title: string, content: string): Step {
    return {
        target: 'body',
        title,
        content,
        placement: 'center',
        skipBeacon: true,
    };
}
